import React from 'react';
// Simple syntax highlighter using <pre> and <code> for demo purposes
function SyntaxHighlight({ text, language }) {
  return (
    <pre style={{ background: '#23272f', color: '#fff', borderRadius: 6, padding: 12, overflowX: 'auto' }}>
      <code className={`language-${language}`}>{text}</code>
    </pre>
  );
}
export default SyntaxHighlight;
